import script from "./TrailerPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./TrailerPlayer.vue?vue&type=script&setup=true&lang=js"

import "./TrailerPlayer.vue?vue&type=style&index=0&id=128058a0&scoped=true&lang=css"

import exportComponent from "/cbx/htdocs/cineweb-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128058a0"]])

export default __exports__